// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterFrontImage_root__3-hY5","title":"AfterFrontImage_title__3j0Zs"};